import {all} from "redux-saga/effects";
import assigneesSagas from "./assigneesSagas";
import authSagas from "./authSagas";
import incidentDetailSagas from "./incidentDetailSagas";
import incidentsSagas from "./incidentsSagas";
import investigationSagas from "./investigationSagas";
import mitreSagas from "./mitreSagas";
import savedInvestigationsSaga from "./savedInvestigationsSagas";
import systemStatusSagas from "./systemStatusSagas";
import usersSagas from "./usersSagas";

export function* rootSaga() {
  yield all([
    assigneesSagas(),
    authSagas(),
    incidentDetailSagas(),
    incidentsSagas(),
    savedInvestigationsSaga(),
    investigationSagas(),
    mitreSagas(),
    systemStatusSagas(),
    usersSagas()
  ]);
}
